<template>
  <v-sheet rounded="xl" >
   
    <v-list  dense class="my-n2">
      <v-list-item>
        <v-list-item-content>
          <div
            style="
              display: flex;
              align-items: center;
              justify-content: space-between;
            "
          >
            <div @click="handleGoLink({ url: `/#Inicio` })">
              <v-icon>mdi-home</v-icon> INICIO
            </div>
            <div
              @click="handleGoLink({ url: `/Carrito/` })"
              v-if="
                dataUser.IndAutenticado &&
                !Cliente.showOpc &&
                dataUser.VerPrecios[tipoMoneda]
              "
            >
            <v-badge
                  :color="
                    Pedido.data.TotItem && Pedido.data.TotItem !== 0
                      ? '#7C2629'
                      : 'transparent'
                  "
                  inline
                  bottom
                  left
                  overlap
                  :content="
                    Pedido.data.TotItem && Pedido.data.TotItem !== 0
                      ? TotalPedido
                      : 0
                  "
                >
                  <v-btn color="primary" icon>
                    <v-icon>mdi-cart-variant</v-icon>
                    {{ Pedido.data.TotItem !== 0 ? Pedido.data.TotItem : "" }}
                  </v-btn>
                </v-badge>
            </div>
          </div>

        </v-list-item-content>
      </v-list-item>

      <v-divider color="#D3BC8D"></v-divider>

      <v-list-group no-action :value="false">
        <template v-slot:activator>
          <v-list-item-icon>
            <v-icon>mdi-view-list</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>PRODUCTOS</v-list-item-title>
          </v-list-item-content>
        </template>
        <v-list dense>
          <v-list-item
            v-for="(item, index) in categorias"
            :key="index"
            link
            @click="handleCat({ item })"
            :to="`/subcategoria/${item.CodigoDiv}/${item.CodigoDep}/${item.Categoria}`"
          >
            <v-list-item-content class="mx-2">
              <v-list-item-title>{{ item.Nombre }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-list-group>
      <v-divider></v-divider>
      <v-list-item link :to="`/#Nosotros`">
        <v-list-item-icon>
          <v-icon>mdi-office-building-marker</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title> NOSOTROS </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      <v-list-item link :to="`/testimonios/`">
        <v-list-item-icon>
          <v-icon>mdi-account-voice</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title> TESTIMONIO </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      <v-list-item link :to="`/#Contacto`">
        <v-list-item-icon>
          <v-icon>mdi-email</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title> CONTACTO </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      <v-list-item
        :to="`/agenda/`"
        link
        v-if="dataUser.IndCargarPedido && linkAgenda(dataUser.TipoUsuario)"
      >
        <v-list-item-icon>
          <v-icon>mdi-calendar-month</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title> AGENDA </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      <v-list-item
        :to="`/mantenimiento/`"
        link
        v-if="dataUser.IndAutenticado && dataUser.IndMantGaleria"
      >
        <v-list-item-icon>
          <v-icon>mdi-cog</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title> MANTENIMIENTOS </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
    </v-list>
  </v-sheet>
</template>

<script>
import { mapMutations, mapActions, mapState } from "vuex";
export default {
  data() {
    return {};
  },
  methods: {
    ...mapMutations([
      "CLR_DATOS_SUBCATB",
      "CLR_DATOS_SUBCATB",
      "CLR_DATOS_SUBCAT",
      "CLR_BUSCAREPUESTO",
      "set_ModelLogin",
      "CLR_BUSCARPROMO",
      "GET_BUSCARSCAT",
      "CLR_BUSCARMARCA",
      "GET_BUSCARCAT",
      "CLR_ERROR_AXIOS",
      "set_changeSubcatF",
      "CLR_DATOS_ART",
      "set_AdPromoF",
      "set_varCategorias",
      "CLR_BUSCARSCAT",
      "set_Cliente",
    
    ]),
    ...mapActions(["get_pedidosPendientes"]),
    handleGoLink({ url }) {
      this.$vuetify.goTo(0);
      this.$router.push({ path: url }).catch((err) => {});
    },
    handleCat({ item: { CodigoDiv, CodigoDep, Categoria } }) {
      window.scrollTo(0, 0);
      this.CLR_DATOS_SUBCAT();
      this.CLR_BUSCARPROMO();
      this.CLR_BUSCARSCAT();
      this.CLR_BUSCARMARCA();
      this.GET_BUSCARCAT(Categoria);
      this.CLR_ERROR_AXIOS();
      this.CLR_DATOS_SUBCATB();
      this.CLR_BUSCAREPUESTO();
      this.set_changeSubcatF();
      this.CLR_DATOS_ART();
      this.set_AdPromoF();
      this.set_varCategorias([CodigoDiv, CodigoDep, Categoria]);
      this.$router
        .push({ path: `/subcategoria/${CodigoDiv}/${CodigoDep}/${Categoria}` })
        .catch((err) => {});
    },
  },
  computed: {
    ...mapState([
   
      "dataUser",
      "maestro",
      "Cliente",
      "tipoMoneda",
      "Pedido",
      "simboloMoneda",
    ]),

    linkAgenda: function () {
      return function (value) {
        return value !== "C";
      };
    },
    TotalPedido() {
      let numeral = require("numeral");
      let monto = numeral(this.Pedido.data.MontoTotal[this.tipoMoneda]).format(
        "0,0.00"
      );
      return this.simboloMoneda[this.tipoMoneda] + " " + monto;
    },
    categorias() {
      if (Object.entries(this.maestro).length !== 0) {
        return this.maestro.ttCategoria;
      }
    },
  },
};
</script>

<style></style>
